import { useMeQuery } from '@cyber/service/pwa';

export function useLinkedinStatus() {
  const { data } = useMeQuery(undefined);
  const meData = data?.me?.data;
  const needRefresh = meData?.privateInfo?.linkedinInfo.needRefresh;
  const isLinked = !!meData?.privateInfo?.linkedinId;
  return { needRefresh, isLinked };
}
